/**
 * Query keys for the cases table.
 *
 * The scope segment replaces the previous concatenated key
 * (`cases_campaign_5_entity_9`). A flat string has no hierarchy, so no
 * invalidation could reach every scoped variant at once; with the scope as its
 * own segment, `caseKeys.all` matches all of them and `caseKeys.list(scope)`
 * matches exactly one.
 */
export const caseKeys = {
  all: ["cases"],
  lists: () => [...caseKeys.all, "list"],
  list: ({ campaignId = null, entityId = null } = {}) => [
    ...caseKeys.lists(),
    { campaignId, entityId },
  ],
};
